<div class="modal-header d-flex justify-content-between align-items-center">
  <h4 i18n="@@transferBotname">{{ bot.name }} übertragen</h4>
  <p-button
    [text]="true"
    [rounded]="true"
    severity="secondary"
    (onClick)="bsModalRef.hide()"
  >
    <ng-template #content>
      <i class="ri ri-close-large-line"></i>
    </ng-template>
  </p-button>
</div>
<div class="modal-body">
  <div class="row mb-1 align-items-center">
    <div class="col-3">
      <label
        for="selectedUser"
        i18n="@@username"
      >Benutzer</label>:
    </div>
    <div class="col">
      <p-select
        inputId="selectedUser"
        name="selectedUser"
        [options]="this.users"
        [(ngModel)]="this.selectedUser"
        optionLabel="name"
        optionValue="_id"
        appendTo="body"
        size="small"
        class="w-100"
      ></p-select>
    </div>
  </div>
</div>
<div class="modal-footer">
  <p-button
    label="Übertragen"
    i18n-label="@@transfer"
    (onClick)="this.transferBot()"
    size="small"
  ></p-button>
</div>